define(['exports'], function (exports) {
	'use strict';

	exports.people_categories = {
		CANDIDATE: 'candidate',
		EMPLOYEE: 'employee'
	};

	exports.CandidatesSelectionTabs = {
		CANDIDATES: 'candidates_list',
		SELECTED_CANDIDATES: 'selected_candidates_list'
	};

	exports.reports_sections = {
		PROGRAMMING: 'programming',
		QUIZ: 'quiz',
		PROJECT: 'project',
		SQL: 'sql',
		WEB: 'web'
		// "CONTEST": "contest",
		// "MCQ": 'MCQ'
	};

	exports.candidate_types = {
		FRESHER: 'FRESHER'
	};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/utils/enums.js
// module id = 283
// module chunks = 0